import React from 'react';
import HeadingSection from '../../components/contact/HeadingSection';
import ContactSection from '../../components/contact/ContactSection';
import FormSection from '../../components/contact/FormSection';
import MapSection from '../../components/contact/MapSection';
import { MetaTags } from 'react-meta-tags';

const Contact = () => {
  return (
    <React.Fragment>
      <MetaTags>
        <title>Contact Us | Subul Contracting</title>
      </MetaTags>

      <HeadingSection />

      <section className="section">
        <ContactSection />
      </section>

      <section className="section bg-light">
        <FormSection />
      </section>

      <section>
        <MapSection />
      </section>
      
    </React.Fragment>
  );
};

export default Contact;